export const NOTIFY_TIMEOUT = 2000
export const GPS_INTERVAL = 5000
export const MAP_MOVE_INTERVAL = 1500
export const MAP_SCALE_INTERVAL = 250
export const GEOFENCE_CIRCULAR = 'GpsGate.Online.Geofence.CircularGeofence'
export const GEOFENCE_ROUTE = 'GpsGate.Online.Geofence.RouteGeofence'
export const MAP_MAX_ZOOM = 16
export const MAP_MIN_ZOOM = 13
export const MAP_DEFAULT_PITCH = 0
export const MAP_DEFAULT_ZOOM = 15
export const MAP_MAX_PITCH = 60
export const MAP_DEFAULT_ROUTE_WIDTH = 6
export const MAP_DEFAULT_ROUTE_OPACITY = 0.5
export const MAP_CENTER = [ 104.05, 49.025 ]
export const MAP_SCALE_SIZE = 2
export const MAP_ANIMATE_INTERVAL = 250

export const DEFAULT_TAG_ID = 47

export const BUS_COLORS = [
  '#00A651',
  '#00FFFF',
  '#0072BC',
  '#EE1C24',
  '#FF00FF',
  '#FFFF00'
]
